enum CheckoutModalViews {
  LOGIN_FORM,
  DISTRIBUTION_DETAILS,
  PERSONAL_DETAILS,
  PAYMENT_DETAILS,
}

export default CheckoutModalViews